<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="900px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    v-el-dialog-drag
  >
    <div>
      <div class="images-container">
        <div class="d-flex flex-wrap block" v-if="!isEmpty">
          <div v-for="(item, index) in listImage" :key="index">
            <div class="image-box">
              <span class="default-icon" v-if="item.isDefault === 'Y'">
                <i class="el-icon-success"></i>
              </span>
              <el-image
                style="width: 100%; height: 100%"
                fit="scale-down"
                :src="item.displayImageUrl"
                :preview-src-list="listImageUrl"
              ></el-image>
              <div class="shadow">
                <div>
                  <span @click="onImagePreview(index)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isEmpty" class="empty-image">
          <div style="text-align: center">
            <img src="/image/static/img/nodata.png" />
            <p class="no-data mt-2">
              {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
            </p>
          </div>
        </div>
      </div>
      <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
        <img
          v-for="item in listImageUrl"
          :src="item || '/image/static/img/nopic.jpg'"
          :key="item"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    amzSpuCode: { type: String, default: '' },
  },
  data() {
    return {
      listImage: [],
      listImageFile: [],
      uploadFileMaxLimit: 10,
    }
  },
  computed: {
    isEmpty() {
      return !this.listImage || !this.listImage.length
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.listImage.map((item) => item.displayImageUrl)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzSpuCode) return
      const res = await this.$api
        .ecomAmzSpuImageListApi({ amzSpuCode: this.amzSpuCode })
        .catch(() => null)
      this.listImage = res.body.data
    },
    onImagePreview(index) {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.images-container {
  min-height: calc(100vh - 502px);
  overflow: auto;
}

.empty-image {
  height: calc(100vh - 502px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
